<template>
    <div class="searchBar" v-if="checkAuthorization">
        <v-expansion-panels v-model="displayForm" multiple>
            <v-expansion-panel :key="'search'">
                <v-expansion-panel-header>
                    <v-card-title>{{ $t('genericSearch.searchParams') }}</v-card-title>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-row>
                        <v-col class="d-flex align-center" xl="3" lg="3" md="3" sm="4" cols="12">
                            <v-autocomplete
                                color="#3200E6"
                                v-model="scopeflowsSearch"
                                :items="scopeflows"
                                :disabled="scopeflows.length === 1"
                                cache-items
                                :label="$t('forms.inbound')"
                            />
                        </v-col>
                        <v-col class="d-flex align-center" xl="3" lg="3" md="3" sm="4" cols="12">
                            <v-autocomplete
                                color="#3200E6"
                                v-model="dimensionsSearch"
                                :items="dimensionsTranslation"
                                :label="$t('forms.geodisid')"
                            />
                        </v-col>
                        <v-col class="d-flex align-center" xl="3" lg="3" md="3" sm="4" cols="12">
                            <v-combobox
                                color="#3200E6"
                                v-model="idSearch"
                                :items="suggestion"
                                :label="$t('forms.search')"
                                @keyup.enter.native="onEnterSearch"
                            />
                        </v-col>
                        <v-col class="d-flex align-center" xl="3" lg="3" md="3" sm="12" cols="12">
                            <v-btn :disabled="!filledForm" @click="searchShipments" class="action" id="actionClick">
                                {{ $t('trackandtrace.displayResults') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
import { api } from '@/utils/api';
import { mapGetters, mapMutations } from 'vuex';
import {
    SET_CONTENT,
    SET_DETAILS,
    SET_DETAILS_REFERENCES,
    SET_DOCUMENTS,
    SET_EVENTS,
    RESET_SHIPMENT_RESULTS,
    SHIPMENT,
    GET_ID_SEARCH,
    SET_ID_SEARCH,
    GET_DIMENSIONS_SEARCH,
    SET_DIMENSIONS_SEARCH,
    GET_SCOPEFLOWS_SEARCH,
    SET_SCOPEFLOWS_SEARCH
} from '../constants/shipment';

export default {
    props: ['clientId', 'initDisplayForm'],
    data() {
        const suggests = JSON.parse(localStorage.getItem('historySuggestionTnT') || '{}');
        const suggestion = suggests[this.clientId] || [];

        return {
            idSearch: '',
            dimensionsSearch: '',
            scopeflowsSearch: '',
            scopeflows: [],
            dimensions: [],
            suggestion,
            displayForm: this.initDisplayForm || [0]
        };
    },
    computed: {
        filledForm() {
            return this.scopeflowsSearch && this.dimensionsSearch && this.idSearch;
        },
        checkAuthorization() {
            return !this.getQueryVariable('osol');
        },
        dimensionsTranslation() {
            return this.dimensions.map(dim => {
                const key = `trackAndTraceSearch.${this.$store.getters.getCurrentClientId}.searchBar.${dim}`;
                return this.$te(key) ? this.$t(key) : this.$t(`trackAndTraceSearch.default.searchBar.${dim}`);
            });
        }
    },
    methods: {
        ...mapGetters(SHIPMENT, [GET_DIMENSIONS_SEARCH, GET_SCOPEFLOWS_SEARCH, GET_ID_SEARCH]),
        ...mapMutations(['setSelectedRow', 'setSubpageNumber', 'setLoading', 'setRingLoading']),
        ...mapMutations(SHIPMENT, [SET_DIMENSIONS_SEARCH, SET_SCOPEFLOWS_SEARCH, SET_ID_SEARCH]),
        ...mapMutations(SHIPMENT, [
            SET_CONTENT,
            SET_DETAILS,
            SET_DETAILS_REFERENCES,
            SET_DOCUMENTS,
            SET_EVENTS,
            RESET_SHIPMENT_RESULTS
        ]),
        getQueryVariable: function (variable) {
            const query = window.location.search.substring(1);
            const vars = query.split('&');
            for (let i = 0; i < vars.length; i++) {
                const pair = vars[i].split('=');
                if (decodeURIComponent(pair[0]) === variable) {
                    return decodeURIComponent(pair[1]);
                }
            }
            return null;
        },
        getHeaderConfigId() {
            return this.$store.getters.getCurrentClientId || 'T&T_default';
        },
        clearSearch() {
            this.idSearch = '';
            this.dimensionsSearch = '';
            this.scopeflowsSearch = '';
        },
        toggle() {
            this.displayForm = !this.displayForm;
        },
        onEnterSearch() {
            const btn = document.getElementById('actionClick');
            if (btn) btn.click();
        },
        async searchShipments() {
            await new Promise(res => setTimeout(res, 100));
            this.resetShipmentResults();
            this.setIdSearch(this.idSearch);
            this.setDimensionsSearch(this.dimensionsSearch);
            this.setScopeflowsSearch(this.scopeflowsSearch);
            if (this.filledForm) {
                //get ws name for the dimension
                const rawDimension = this.dimensions[this.dimensionsTranslation.indexOf(this.dimensionsSearch)];
                const dimension = this.$store.getters.getDimensionWSName(rawDimension);
                const scopeflowOfClient = this.$store.getters.getScopeflowIfClient(this.scopeflowsSearch);
                const body = {
                    scopeflow: this.scopeflowsSearch,
                    isClient: scopeflowOfClient,
                    [dimension]: this.idSearch,
                    clientId: this.$store.state.clients.current
                };
                this.setLoading(true);
                this.toggle();
                const response = await api.post('search', body).catch(err => {
                    this.setLoading(false);
                });

                if (response) {
                    const suggests = JSON.parse(localStorage.getItem('historySuggestionTnT') || '{}');
                    const array = [...(suggests[this.clientId]?.slice(-5) || [])];
                    localStorage.setItem(
                        'historySuggestionTnT',
                        JSON.stringify({
                            ...suggests,
                            [this.clientId]: [...array, ...(array.includes(this.idSearch) ? [] : [this.idSearch])]
                        })
                    );

                    this.$store.commit('storeScopeflowsResult', response);
                    this.$store.commit('setNbShipments', response.length);
                    this.setLoading(false);
                    if (response.length === 1) {
                        this.$router
                            .push({
                                path: `/${this.$store.getters.getClientName}/trackandtrace/shipment`,
                                query: {
                                    id: response[0].customerServiceNumber,
                                    churef: response[0].customerHUReference,
                                    tab: 'Details'
                                }
                            })
                            .catch(err => {});
                        this.$emit('research');
                    } else {
                        this.setSelectedRow({});
                        this.$router.push({ path: `/${this.$store.getters.getClientName}/trackandtrace` }).catch(err => {});
                    }
                } else {
                    this.$store.commit('storeScopeflowsResult', null);
                }
            }
        },
        async setScopeflows() {
            if (!this.clientId) return false;
            const data = await api.get('scopeflows', { id: this.clientId });
            this.$store.commit('setClientId', data);
            this.$store.commit('setScopeflows', data);
            this.$store.commit('setDimensions', data);
            this.scopeflows = this.$store.getters.getScopeflows;
            this.dimensions = this.$store.getters.getDimensions;
            this.scopeflowsSearch = this.scopeflows[0] || null;
        },
        setRawDimensions() {
            this.dimensions = this.$store.getters.getDimensions;
        }
    },
    mounted() {
        this.resetShipmentResults();
    },
    async created() {
        await this.setScopeflows();
        if (this.scopeflows.includes(this.getScopeflowsSearch())) {
            this.scopeflowsSearch = this.getScopeflowsSearch();
            this.idSearch = this.getIdSearch();
            this.dimensionsSearch = this.getDimensionsSearch();
        } else {
            this.scopeflowsSearch = this.scopeflows?.length === 1 ? this.scopeflows[0] : '';
            this.idSearch = '';
            this.dimensionsSearch = '';
        }
    },
    watch: {
        clientId: function (newValue) {
            this.setScopeflows();
        }
    }
};
</script>

<style lang="scss" scoped>
.searchBar {
    margin-bottom: 20px;
}

.search-bar-button {
    margin-left: 20px;
}

.search-bar-nb-shipments {
    white-space: nowrap;
    color: #311b92;
}

.v-card__actions {
    position: absolute;
    top: 5px;
    right: 20px;
}

.v-card__title {
    word-break: break-word;
}

.form {
    overflow: hidden;
    &._hidden {
        height: 0px;
        padding: 0;
    }
}

.lds-ring {
    display: inline-block;
    position: relative;
    width: 20px;
    height: 20px;
    margin-left: 18px;
}
.lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 16px;
    height: 16px;
    margin: 2px;
    border: 2px solid #311b92;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #311b92 transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
}
@keyframes lds-ring {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
